import styled from 'styled-components';

export const InfoWrapper = styled('p')`
  display: inline-block;
  position: relative;
  padding: 8px 16px 8px 40px;
  align-items: center;
  border-radius: 10px;
  border: 1px solid #858dbd;
  color: var(--color-text-muted);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  margin: 0 0 20px;
  text-align: left;

  .info-icon {
    pointer-events: none;
    position: absolute;
    top: 50%;
    left: 10px;
    transform: translateY(-50%);
    color: var(--color-text-muted);
  }
`;
